var render = function (_h,_vm) {var _c=_vm._c;return _c('v-flex',{staticClass:"nx-bag-block-button"},[_c('v-btn',_vm._g({staticClass:"ma-0",attrs:{"color":"secondary","block":"","loading":_vm.props.loading}},_vm.listeners),[_vm._v("\n    "+_vm._s(_vm.props.title)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }